export const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(/\s+/);
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    } else {
      return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }
};

export const cutString = (str, maxLength) => {
    if (str.length > maxLength) {
      str = str.substring(0, maxLength - 1);
      str = str + "...";
    }
    return str;
};

export const getGroupMembers = (group) => {
    if (!group || !Array.isArray(group.Members)) return [];

    return group.Members.map((member) => (
      <div key={member?.User?.Id}>
        {member?.User?.Name} ({member?.User?.Role?.Name})
      </div>
    ));
};

export const getAvatarColor = (user, selectedOwners) => {
  if (user?.IsGroup) {
    return selectedOwners?.some(owner => owner.Id === user?.Id && owner.IsGroup)
      ? "dark-red"  
      : "red"; 
  } else {
    return selectedOwners?.some(owner => owner.Id === user?.Id && !owner.IsGroup)
      ? "brand"
      : "blue";
  }
};

export const sortProjectMembers = (users, selectedOwners = [], selectedMembers = []) => {
    return [...users].sort((a, b) => {
      const isAUser = !a.IsGroup;
      const isBUser = !b.IsGroup;
  
      const isASelectedOwner = selectedOwners.some(owner => owner.Id === a.Id && owner.IsGroup === a.IsGroup);  
      const isBSelectedOwner = selectedOwners.some(owner => owner.Id === b.Id && owner.IsGroup === b.IsGroup);
  
      if (isASelectedOwner && !isBSelectedOwner) return -1;
      if (!isASelectedOwner && isBSelectedOwner) return 1;
  
      const isSelectedA = selectedMembers.some(m => m.Id === a.Id && m.IsGroup === a.IsGroup);
      const isSelectedB = selectedMembers.some(m => m.Id === b.Id && m.IsGroup === b.IsGroup);
  
      if (isSelectedA && !isSelectedB) return -1;
      if (!isSelectedA && isSelectedB) return 1;
  
      if (isSelectedA && isSelectedB) {
        if (isAUser && !isBUser) return -1;
        if (!isAUser && isBUser) return 1;
      }
  
      if (isAUser && !isBUser) return -1;
      if (!isAUser && isBUser) return 1;
  
      return a.Name.localeCompare(b.Name);
    });
  };
  